export enum ModalName {
  Match = 'match',
  MatchLeaderboard = 'match_leaderboard',
  MatchResult = 'match_result',
  CreateMatch = 'create_match',
  SearchUsers = 'search_users',
  Tournament = 'tournament',
  CreateAnnouncement = 'create_announcement',
  PlatformLinking = 'platform_linking',
  PlatformLinkingManual = 'platform_linking_manual',
  TournamentCode = 'tournament_code',
  TournamentMatchDetails = 'tournament_match_details',
  BalanceAddFunds = 'balance_add_funds',
  BalanceWithdrawFunds = 'balance_withdraw_funds',
  BalanceWithdrawFundsConfirmed = 'balance_withdraw_funds_confirmed',
  BalanceSwap = 'balance_swap',
  BalanceAutoSwap = 'balance_auto_swap',
  EditWithdrawRequest = 'edit_withdraw_request',
  Chat = 'chat',
  Uploader = 'uploader',
  Feedback = 'feedback',
  FullScreenBracket = 'full_screen_bracket',
  CreateAffiliateProgram = 'create_affiliate_program',
}
